var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"color":"#b1b1b2"}},[_vm._v("Не заполняется")])}
var staticRenderFns = []

export { render, staticRenderFns }